export const DEFAULT_URL = import.meta.env.VITE_BASE_URL;

export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL;

export const DOWN_URL = import.meta.env.VITE_DOWN_URL;
